'use strict';

var App = require('app');
var AppState = require('app_state');
var AbstractWizardView = require('components/common/views/abstract_wizard_view');
var Consts = require('consts');
var DeviceFilterView = require('components/devices/views/common/device_filter_view');
var WizardDeviceSelectView = require('components/devices/views/common/wizard_device_select_view');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var DeviceSelection = require('utils/device_selection');

var globalCfg = undefined;

function initControls() {
    if (globalCfg.isLarge) $('#js-modal-dialog .modal-dialog').addClass('modal-lg');

    setTimeout(function () {
        Misc.initSelectPicker({ class: 'form-control' });
    });
}

function loadDevices(config, callback) {
    var self = this;
    var filter = config.isFilter
        ? config.filter
        : { selection: config.defaultSelectionID, category: config.filter.category };
    var devicesReq = App.request('device:list', {
        filterParams: { limit: AppState.getItemsPerPage(), onError: 'emptyList' },
        filter: filter,
    });
    config.backgroundTasks.when(devicesReq).done(function (devices) {
        config.filterCache.lastDeviceList = devices;
        config.filterCache.lastCount = devices.count;
        if (callback) callback(devices);
    });
}

function triggerUpdateWizardButtons(frm, config, callback) {
    frm.backgroundTasks.done(function () {
        if (config && config.selection) {
            config.selection.done(function () {
                frm.updateWizardButtons();
                if (callback) {
                    callback();
                }
            });
        } else {
            frm.updateWizardButtons();
            if (callback) {
                callback();
            }
        }
    });
}

function toggleSelection(frm, config, isVisible) {
    if (isVisible) {
        var deviceList = config.filterCache.lastDeviceList;
        if (deviceList) {
            config.showSelectDevices = true;
            config.selection =
                config.selection || new DeviceSelection({ filter: config.filter, count: deviceList.count });
            config.hasVirtualDevices =
                Misc.countWhere(deviceList.items.models, function (item) {
                    return item.get('category') == Consts.CategoryData.Virtual.category;
                }) > 0;

            var deviceSelectionView = new WizardDeviceSelectView({
                controller: frm.controller,
                deviceList: deviceList,
                config: config,
                onSelectionChanged: function () {
                    frm.updateWizardButtons();
                    setTimeout(function () {
                        triggerUpdateWizardButtons(frm, config, function () {
                            if (frm.wizardConfig.onFilterSelectionDone) {
                                frm.wizardConfig.onFilterSelectionDone.apply(frm);
                            }
                        });
                    });
                },
            });

            frm.showChildView(config.selectionRegion, deviceSelectionView);
            frm.updateWizardButtons();
            config.lastSelectionView = deviceSelectionView;
        }
    } else {
        config.selection = undefined;
        config.showSelectDevices = false;
        if (config.lastSelectionView) config.lastSelectionView.destroy();
    }
}

function refreshFilter(filterView, config, filter, frm) {
    filter.conditions = filter.conditions || [];
    if (JSON.stringify(filter) != JSON.stringify(config.filter)) {
        if (filter) {
            config.showSelectDevices = false;
            config.filter = Misc.cloneAsJSON(filter);
            config.selection = undefined;
        }
        // read first batch of devices
        loadDevices(config, function (deviceList) {
            if (filterView) {
                filterView.setDeviceCount(deviceList.count);
            }
        });
    } else {
        if (filterView && config.filterCache.lastDeviceList)
            filterView.setDeviceCount(config.filterCache.lastDeviceList.count);
    }

    triggerUpdateWizardButtons(frm, config);
}

module.exports = OOP.extend(
    AbstractWizardView,
    {
        filterConfig: undefined,
        regions: OOP.inheritedObj('regions', {}),
        events: OOP.inheritedObj('events', {
            'click .js-select-devices-cb': function (e) {
                var self = this;
                var configName = $(e.currentTarget).attr('data-config-name');
                var isChecked = $(e.currentTarget).prop('checked');

                toggleSelection(this, this.filterConfig, isChecked);
                triggerUpdateWizardButtons(self, this.filterConfig);
            },
        }),

        installFilter: function (sourceData, cfg) {
            globalCfg = cfg || {};
            if (globalCfg.isLarge === undefined) globalCfg.isLarge = true;

            this.filterConfig = {
                backgroundTasks: this.backgroundTasks,
                filterRegion: 'device-filter',
                selectionRegion: 'device-selection',
                selection: undefined,
                filterCache: {},
                filter: Misc.cloneAsJSON(sourceData.filter),
                isFilter: sourceData.selection === undefined,
                defaultSelectionID: sourceData.selection,
                onValidateFilter: globalCfg.onValidateFilter,
                noGroups: globalCfg.noGroups,
            };

            var config = this.filterConfig;

            // create regions
            var regions = {};
            var config = this.filterConfig;
            regions[config.filterRegion] = 'div#' + config.filterRegion;
            regions[config.selectionRegion] = 'div#' + config.selectionRegion;
            this.addRegions(regions);

            var result = {};
            Object.defineProperty(result, 'filter', {
                get: function () {
                    if (config.selection && config.selection.selectionID) {
                        config.filter = config.filter || { category: undefined };
                        return { selection: config.selection.selectionID, category: config.filter.category };
                    } else return config.filter;
                },
            });

            Object.defineProperty(result, 'isVirtual', {
                get: function () {
                    if (config.selection && config.selection.selectionID) return config.hasVirtualDevices;

                    if (config.filter) {
                        return Misc.isFilterTypeVirtual(config.filter.type);
                    }

                    return false;
                },
            });

            return result;
        },

        doWizardNext: function () {
            var self = this;
            var config = this.filterConfig;

            if (self.selected == config.filterTab) {
                if (!config.lastFilterView.isValid()) {
                    config.lastFilterView.render();
                    return;
                }
                if (!config.filterCache.lastDeviceList) {
                    loadDevices(config);
                }
            }

            this.backgroundTasks.done(function () {
                this.base.doWizardNext();
            }, this);
        },

        gotoFilterSelectionTab: function (config) {
            var self = this;
            if (config.showSelectDevices || !config.isFilter) {
                toggleSelection(this, config, true);

                if (!config.isFilter) {
                    refreshFilter(
                        undefined,
                        config,
                        { category: config.filter.category, selection: config.defaultSelectionID },
                        this
                    );
                    this.backgroundTasks.done(function () {
                        toggleSelection(this, config, true);
                    }, this);
                }
            } else {
                setTimeout(function () {
                    if (self.wizardConfig.onFilterSelectionDone) {
                        self.wizardConfig.onFilterSelectionDone.apply(self);
                    }
                });
            }
        },

        gotoFilterTab: function (config) {
            var self = this;
            var deviceFilter = new DeviceFilterView({
                controller: self.controller,
                showDeviceCount: true,
                container: '#js-modal-dialog',
                onValidateFilter: function (filterView) {
                    if (config.onValidateFilter) {
                        var errObj = {};
                        config.onValidateFilter(filterView.getFilter(), errObj);
                        filterView.errors = errObj;
                        return !_.keys(errObj).length;
                    }
                    return true;
                },
                onFilterChanged: function (filter) {
                    refreshFilter(deviceFilter, config, filter, self);
                },
                onLoadComplete: function () {
                    self.showChildView(config.filterRegion, deviceFilter);
                    if (self.wizardConfig.onFilterDevicesDone) {
                        self.wizardConfig.onFilterDevicesDone.apply(self);
                    }
                },
                defaultFilter: config.filter,
                cache: config.filterCache,
                noGroups: config.noGroups,
            });
            config.lastFilterView = deviceFilter;
        },

        canWizardFinish: function () {
            var prev = this.base.canWizardFinish();
            if (!prev) return prev;
            if (this.backgroundTasks.isBusy() || (this.filterConfig.selection && this.filterConfig.selection.isBusy()))
                return false;

            return !this.filterConfig.selection || !this.filterConfig.selection.isEmpty();
        },

        canWizardChange: function (is, was) {
            if (!this.filterConfig) {
                throw 'installFilter not executed';
            }
            var prev = this.base.canWizardChange(is, was);
            if (!prev) return prev;

            if (this.backgroundTasks.isBusy() || (this.filterConfig.selection && this.filterConfig.selection.isBusy()))
                return false;

            if (was == this.filterConfig.filterTab && !this.filterConfig.lastFilterView.isValid()) {
                return false;
            }

            return (
                was != this.filterConfig.selectionTab ||
                is < was ||
                !this.filterConfig.selection ||
                !this.filterConfig.selection.isEmpty()
            );
        },

        getTabNames: OOP.inheritedObj('getTabNames', {
            Filter: I18N.TR('Filter'),
            Devices: I18N.TR('Geräte'),
        }),

        onGotoPage: function (page, previous) {
            var self = this;
            var config = this.filterConfig;
            if (!config) {
                throw 'installFilter not executed';
            }
            switch (page) {
                case config.filterTab:
                    self.gotoFilterTab(config);
                    break;
                case config.selectionTab:
                    self.gotoFilterSelectionTab(config);
                    break;
            }
            initControls();
        },

        serializeData: function () {
            var wizardCtx = this.getWizardContext();
            var data = this.base.serializeData();
            data.filterConfig = this.filterConfig;
            data.filterConfig.wizardCtx = wizardCtx;
            data.wizardContext = wizardCtx;
            return data;
        },
    },
    'FilterSelectWizardView'
);
